/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_Credits_RequiredInputs */

const en_pricing_public_credits_required = /** @type {(inputs: Pricing_Public_Credits_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get credits to make this video`)
};

const es_pricing_public_credits_required = /** @type {(inputs: Pricing_Public_Credits_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigue créditos para crear este video`)
};

/**
* | output |
* | --- |
* | "Get credits to make this video" |
*
* @param {Pricing_Public_Credits_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_credits_required = /** @type {((inputs?: Pricing_Public_Credits_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Credits_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_credits_required(inputs)
	return es_pricing_public_credits_required(inputs)
});